<template>
    <div :class="['package-cloud']">
        <h2 class="user-page recommended-item__title" v-html="$t('LandingPage.recommended_items_topics_title')"></h2>
        <div class="package-cloud__container">
            <TotemButton
                v-for="category in filteredPackages"
                :key="`category-cloud-button-${category.code}`"
                size="medium"
                color="package-cloud"
                @click="goToPackageView(category.code)"
                :label="category.translatedName"
            />
            <TotemButton
                size="medium"
                color="package-cloud"
                fontStyle="bold"
                @click="goToAllPackages"
                :label="$t('Menu.browse_all')"
            />
        </div>
    </div>
</template>

<script>

    import TotemButton from 'components/shared/global-forms/totem-button'
    import { mapGetters } from 'vuex'
    import { translateWithDefault } from 'helpers/i18nHelper'
    import accessHelper from 'helpers/accessHelper'
    export default {
        components: { TotemButton },
        computed: {
            ...mapGetters({
                userPackages: 'User/getPackageInfo',
                isLoggedIn: 'isLoggedIn'
            }),
            filteredPackages () {
                let packages = this.userPackages
                if (this.isLoggedIn) {
                    packages = packages.filter(packageItem => packageItem.accessLevel >= accessHelper.ACCESS_LEVEL_FULL)
                }
                return packages
                    .filter(packageItem => packageItem.visibleInMenu)
                    .map(packageItem => ({
                        ...packageItem,
                        translatedName: translateWithDefault(packageItem.code, packageItem.name)
                    }))
            }
        },
        methods: {
            goToPackageView (packageSlug) {
                this.$store.dispatch('Search/clearAllFilters')
                this.$store.dispatch('Search/setMainPackage', packageSlug)
                this.$router.push({ name: 'all-content', params: { packageSlug } })
            },
            goToAllPackages () {
                this.$router.push({ name: 'all-packages-all-content' })
            }
        }
    }
</script>

<style lang="scss" scoped>
.package-cloud {
    --item-spacing: 10px;
    margin: 0 0 30px;

    [class*="desktop"] {
        margin: 0 0 40px;
    }

    &::v-deep .totem-button .totem-button__content {
        font-size: 1.5rem;

        @media (min-width: 1080px) {
            font-size: 1.6rem;
        }
    }

    &::v-deep .totem-button.medium {
        margin-bottom: calc(var(--item-spacing) );
        margin-right: calc(var(--item-spacing));
        height: unset;
        min-height: 40px;
        padding: 14px 10px;
    }

    &__container {
        flex-wrap: wrap;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 30px 0 0 0;
    }
}
</style>
